import { createContext, useContext, useState, type ReactNode } from 'react';

const ActionsMobileMenuContainerContext = createContext<HTMLUListElement | null>(null);
const ActionsMobileMenuRegisterContext = createContext<(element: HTMLUListElement | null) => void>(() => {});

export function ActionsMobileMenuProvider({ children }: { children: ReactNode }) {
  const [container, setContainer] = useState<HTMLUListElement | null>(null);

  return (
    <ActionsMobileMenuRegisterContext.Provider value={setContainer}>
      <ActionsMobileMenuContainerContext.Provider value={container}>
        {children}
      </ActionsMobileMenuContainerContext.Provider>
    </ActionsMobileMenuRegisterContext.Provider>
  );
}

export function useActionsMobileMenuContainer(): HTMLUListElement | null {
  return useContext(ActionsMobileMenuContainerContext);
}

export function useRegisterActionsMobileMenuContainer(): (element: HTMLUListElement | null) => void {
  return useContext(ActionsMobileMenuRegisterContext);
}
